import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=563ae4b8&scoped=true&"
import script from "./Revision.vue?vue&type=script&lang=ts&"
export * from "./Revision.vue?vue&type=script&lang=ts&"
import style0 from "./Revision.vue?vue&type=style&index=0&id=563ae4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ae4b8",
  null
  
)

export default component.exports